// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.modal-card-body[data-v-30af6e4d] {\n  min-height: 50vh;\n}\n", ""]);
// Exports
module.exports = exports;
